module.exports = __webpack_public_path__ + "static/media/visa_card.1387629c.svg";